<template>
  <div class="content flex-box vertical no-padding">
    <div class="content-title">送机服务设置</div>
    <div class="flex-grow">
      <a-spin :spinning="loading" v-if="loading"></a-spin>
      <div class="delivery-set" v-if="edit">
        <form-area
          ref="setForm"
          class="flex-box vertical"
          layout="horizontal"
          hide-btn
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 21 }"
          :items="items"
          :entity="form"
        >
        </form-area>
      </div>
      <div class="delivery-set" v-else>
        <div class="detail-info-item" v-for="item in infoList" :key="item.key">
          <div class="detail-info-label">{{ item.label }}</div>
          <div class="detail-info-value">{{ item.value || '未设置'}}
          </div>
        </div>
      </div>
    </div>
    <template v-if="editable">
      <a-space class="footer" v-if="edit">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="save" :loading="loading">保存</a-button>
      </a-space>
      <a-space class="footer" v-else>
        <a-button type="primary" @click="editSet">编辑</a-button>
      </a-space>
    </template>
  </div>
</template>

<script lang="tsx">
    import { getDate } from "../../../common/js/tool";
    import mixins from "../mixins";

    export default {
        name: "DeliverySet",
        mixins: [mixins],
        inject: ["parent"],
        data() {
            return {
                loading: false,
                config: null,
                edit: false,
                form: {},
                items: [
                    {
                        key: "delivery_start_time",
                        label: "服务开始时间",
                        component: "a-date-picker",
                        props: {
                            showTime: true,
                            format: "YYYY-MM-DD HH:mm",
                            valueFormat: "YYYY-MM-DD HH:mm",
                            placeholder: "开始时间",
                        },
                        rules: [
                            { required: true, message: "请设置服务开始时间", trigger: "change" },
                        ],
                    },
                    {
                        key: "delivery_end_time",
                        label: "服务结束时间",
                        component: "a-date-picker",
                        props: {
                            showTime: true,
                            format: "YYYY-MM-DD HH:mm",
                            valueFormat: "YYYY-MM-DD HH:mm",
                            placeholder: "结束时间",
                        },
                        rules: [
                            { required: true, message: "请设置服务结束时间", trigger: "change" },
                        ],
                    }
                ],
                moduleKey: 'delivery-set',
            }
        },
        computed: {
            infoList() {
                const activity = this.activity;
                const res = [
                    { label: '服务开始时间', value: '', key: 'start' },
                    { label: '服务结束时间', value: '', key: 'end' },
                ]
                if (activity) {
                    if (activity.delivery_start_time) {
                        res[0].value = getDate(activity.delivery_start_time).pattern("yyyy-MM-dd HH:mm");
                    }
                    if (activity.delivery_end_time) {
                        res[1].value = getDate(activity.delivery_end_time).pattern("yyyy-MM-dd HH:mm");
                    }
                }
                return res;
            },
            activity() {
                return this.$store.getters.activity;
            },
        },
        methods: {
            cancel() {
                this.edit = false;
            },
            save() {
                this.loading = true;
                this.$refs.setForm.handleConfirm().then(form => {
                    const data = { ...form };
                    const activity = this.activity;
                    let url = `/activity/activity/${activity.id}`, method = "PATCH";
                    this.$axios({
                        url,
                        method,
                        data,
                    })
                        .then(() => {
                            this.parent && this.parent.getActivity();
                            this.edit = false;
                            this.$message.success("已保存");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }).finally(() => {
                    this.loading = false;
                })
            },
            editSet() {
                const form = {};
                if (this.activity) {
                    form.delivery_start_time = this.activity.delivery_start_time;
                    form.delivery_end_time = this.activity.delivery_end_time;
                }
                this.form = form;
                this.edit = true;
            },
        }
    }
</script>

<style scoped lang="less">
  .delivery-set {
    margin: 0 auto;
    padding: @padding-md;
    max-width: 1080px;
  }
</style>
